import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	FreudAutoCompleteModule,
	FreudButtonModule,
	FreudDialogModule,
	FreudInputTextModule,
	FreudLoaderModule,
	FreudRadioButtonModule,
	FreudSelectModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { OfficeModalModule } from '@office-ui/modal/modal.module';
import { NgxMaskModule } from 'ngx-mask';
import { TabsRowModule } from 'shared/components/tabs-row/tabs-row.module';
import { SharedModule } from 'shared/shared.module';

import { CGISearchModule } from '../../cgi-search/cgi-search.module';
import { MemedIntegrationModule } from '../../memed-integration/memed-integration.module';
import { PromptuaryCGIModule } from '../../promptuary-cgi/promptuary-cgi.module';
import { PromptuaryComplianceSectionModule } from '../../promptuary-compliance-section/promptuary-compliance-section.module';
import { PromptuaryNoShowModule } from '../../promptuary-no-show/promptuary-no-show.module';
import { PromptuaryOutcomeModule } from '../../promptuary-outcome/promptuary-outcome.module';
import { PromptuaryReasonsModule } from '../../promptuary-reasons/promptuary-reasons.module';
import { PromptuaryRegisterModalComponentModule } from '../../promptuary-register-modal/promptuary-register-modal.module';
import { PromptuaryServiceEvolutionCRMModule } from '../../promptuary-service-evolution-crm/promptuary-service-evolution-crm.module';
import { PromptuaryTaskModule } from '../../promptuary-task/promptuary-task.module';
import { StatusIconModule } from '../../status-icon/status-icon.module';
import { PromptuaryFormCRM } from './promptuary-form-crm.component';

@NgModule({
	declarations: [PromptuaryFormCRM],
	imports: [
		CommonModule,
		SharedModule,
		TranslateModule.forChild(),
		PromptuaryReasonsModule,
		PromptuaryCGIModule,
		PromptuaryNoShowModule,
		FreudButtonModule,
		CGISearchModule,
		TabsRowModule,
		FreudRadioButtonModule,
		FreudSelectModule,
		FormsModule,
		FreudAutoCompleteModule,
		FreudDialogModule,
		FreudInputTextModule,
		FreudLoaderModule,
		NgxMaskModule.forChild(),
		OfficeModalModule,
		MemedIntegrationModule,
		StatusIconModule,
		PromptuaryComplianceSectionModule,
		PromptuaryRegisterModalComponentModule,
		PromptuaryOutcomeModule,
		PromptuaryServiceEvolutionCRMModule,
		PromptuaryTaskModule,
		ReactiveFormsModule,
	],
	exports: [PromptuaryFormCRM],
	providers: [],
})
export class PromptuaryFormCrmModule {}
